export const SquareConnectorsActionTypes = {
    API_RESPONSE_SUCCESS: '@@square_connectors/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@square_connectors/API_RESPONSE_ERROR',
    CREATE_INTEGRATION_AND_START_OAUTH_REQUEST: '@@square_connectors/CREATE_INTEGRATION_AND_START_OAUTH_REQUEST',
};
